import React, { useState } from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Modal from "@amzn/meridian/modal";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import plusKnockoutTokens from "@amzn/meridian-tokens/base/icon/plus-knockout";
import UpsertBreak from "./UpsertBreak";

const CreateBreakModal = ({ allBreaks, fcId, onSubmit, breakConfigs }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Column>
      <Row alignmentHorizontal="end" widths="fit">
        <Button onClick={() => setIsOpen(true)} type="tertiary">
          <Icon tokens={plusKnockoutTokens} />
          Add Event
        </Button>
      </Row>
      <Modal
        title="New Event"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        closeLabel="Close"
      >
        {isOpen && (
          <UpsertBreak
            allBreaks={allBreaks}
            breakConfig={{ site_id: fcId, break_associate_percentage: 1 }}
            onSubmit={(daysOfWeek, breakConfig) =>
              onSubmit(daysOfWeek, {}, breakConfig)
            }
            onCancel={() => setIsOpen(false)}
            isEdit={false}
            breakConfigs={breakConfigs}
          />
        )}
      </Modal>
    </Column>
  );
};
export default CreateBreakModal;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ssd/CreateBreakModal.js